// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://qdofsptupubwemvozjai.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFkb2ZzcHR1cHVid2Vtdm96amFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNjc3MTAsImV4cCI6MjA1ODk0MzcxMH0.S32QtdHstT-2xozGRB2Eps6_Edvi6iDSEJwW0sJtqIE';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    debug: false,
  },
  global: {
    headers: {
      'X-Client-Info': 'supabase-js-web/2.49.4',
    },
  },
});

// Define TypeScript types for our RPC functions
declare module '@supabase/supabase-js' {
  interface SupabaseClient<Database = any> {
    rpc<T = any>(
      fn:
        | 'add_patient'
        | 'get_patients'
        | 'delete_organization'
        | 'delete_organization_for_user'
        | 'get_user_profile'
        | 'get_user_organization'
        | 'get_user_organization_details'
        | 'get_certificates'
        | 'add_certificate'
        | 'get_staff'
        | 'add_staff_member'
        | 'add_appointment'
        | 'get_appointments'
        | 'create_user'
        | 'get_organization_users'
        | 'get_calendar_events'
        | 'verify_invitation'
        | 'mark_invitation_as_used'
        | 'create_invitation'
        | 'get_examinations'
        | 'add_examination'
        | 'update_examination'
        | 'get_examination_by_appointment_id'
        | 'get_organization_settings'
        | 'set_organization_settings'
        | 'get_doctor_settings'
        | 'set_doctor_settings'
        | 'get_last_certificate_number'
        | 'get_certificates_from_schema'
        | 'add_certificate_to_schema'
        | 'delete_certificate'
        | 'delete_patient'
        | 'delete_appointment'
        | 'delete_examination'
        | 'update_appointment'
        | 'get_organization_services'
        | 'get_organization_service_scope'
        | 'set_organization_service_scope'
        | 'add_service'
        | 'update_service'
        | 'delete_service'
        | 'update_service_with_details'
        | 'get_staff_schedules'
        | 'manage_staff_schedule'
        | 'delete_staff_schedule'
        | 'get_examination_by_id'
        | 'get_organization_details'
        | 'set_organization_details'
        | 'generate_examination_number'
        | 'log_patient_access'
        | 'search_icd10',
      params?: object
    ): { data: T | null; error: Error | null };
  }
}
